import React, { Component } from 'react';

//Other Helpers
import BlurImageLoader from 'react-blur-image-loader'
import {Link} from 'react-router-dom';

class ProductNode extends Component {

    render() {
        if (this.props.loading === 'loading') {
            return (
                <div className="product-wrapper loading">
                    <div className="product-image-stage skeleton-image-stage" />
                    <div className="product-card-body">
                        <div className="skeleton-title-line" />
                        <div className="product-card-footer">
                            <div className="skeleton-price-pill" />
                            <div className="skeleton-cta-pill" />
                        </div>
                    </div>
                </div>
            );
        }

        const item = this.props.item;
        const hasStrikePrice = Number(item.strike_price) > 0;
        const specsList = Array.isArray(item.specifications) ? item.specifications.slice(0, 3) : [];
        const targetUrl = item.acc_id ? `/accessory/${item.page_uri}` : `/cycle/${item.page_uri}`;

        return (
            <div className="product-wrapper">
                <div className="product-image-stage">
                    <BlurImageLoader
                        src={item.cloudinary_path + 'c_fill,h_500,q_95,w_650/' + item.thumb_image_id}
                        preview={item.cloudinary_path + 'c_fill,h_10,q_10,w_10/' + item.thumb_image_id}
                        fullCover={true}
                        maxBlurLevel={10}
                        transitionTime={400}
                    />

                    {hasStrikePrice ? (
                        <span className="sale-badge">Tilbud</span>
                    ) : null}

                    {specsList.length > 0 ? (
                        <div className="specs-hover-drawer">
                            <div className="specs-drawer-header">
                                <span className="specs-drawer-title">
                                    <i className="pe-7s-tools" /> Specifikationer
                                </span>
                            </div>
                            <div className="specs-drawer-list">
                                {specsList.map((spec, i) => (
                                    <div className="spec-row" key={i}>
                                        <span className="spec-key">{spec.spec_name}</span>
                                        <span className="spec-val">{spec.spec_value}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : null}
                </div>

                <div className="product-card-body">
                    <h2 className="product-card-title" title={item.title}>
                        {item.title}
                    </h2>

                    <div className="product-card-footer">
                        <div className="price-wrap">
                            {hasStrikePrice ? (
                                <span className="old-price">DKK {item.strike_price}</span>
                            ) : null}
                            <span className="current-price">DKK {item.final_price}</span>
                        </div>

                        <span className="card-cta-pill">
                            Se produkt <i className="pe-7s-angle-right" />
                        </span>
                    </div>
                </div>

                <Link className="link" to={targetUrl} aria-label={item.title} />
            </div>
        );
    }
}

export default ProductNode;



// WEBPACK FOOTER //
// ./src/Reducer/ProductNode.js